import { SvgIcon, SvgIconProps } from '@mui/material';

export function FilterListIcon(props: SvgIconProps): React.JSX.Element {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M5 6H19M8 12H16M10.5 18H13.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
}
